module.exports = __webpack_public_path__ + "img/is2.efee6a40.svg";